import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-overview-location-v2',
    templateUrl: './overview-location-v2.component.html',
    styleUrls: ['./overview-location-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OverviewLocationV2Component implements OnInit {
@Input() locationDetails;
@Input() locationData;
  constructor(public translate: TranslateService) { }

  ngOnInit() {
    console.log("this.locationDetails",this.locationDetails)
    console.log("this.locationData",this.locationData)
  }

}
